import { render, staticRenderFns } from "./StorageSpaceShow.vue?vue&type=template&id=491806d5&"
import script from "./StorageSpaceShow.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports